import { AxiosError, AxiosResponse } from 'axios';
import useSWR, { mutate } from 'swr';

import { ApiComponent } from '../../content/models/ApiComponent';
import Config from '../config';

export function useComponents(lessonkey: number, lessonVersion: number) {
  const url =
    lessonkey && lessonVersion
      ? `${Config.API}/api/component/list/component/module/${lessonkey}/version/${lessonVersion}`
      : undefined;

  const { data: response, error } = useSWR<
    AxiosResponse<ApiComponent[]>,
    AxiosError<Error>
  >(url);

  function update() {
    mutate(url);
  }

  return {
    loading: !response,
    error: !!error,
    data: response?.data,
    update
  };
}
